export default __webpack_public_path__ + "static/guide-0d7680a869e88b6fe87d785f94d5d24e.png";